import { render } from "./expiredView.vue?vue&type=template&id=839b05d4"
import script from "./expiredView.vue?vue&type=script&lang=js"
export * from "./expiredView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__